import { createContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

export type DataRoomNodeActionsContextType = {
  /** Nodes the currently open action drawer/modal acts on. */
  actionNodes: DataRoomNode[];
  /** True while any of the shared action drawers is open. */
  isAnyActionOpen: boolean;
  openRename: (nodes: DataRoomNode[]) => void;
  openMove: (nodes: DataRoomNode[]) => void;
  openManageAccess: (nodes: DataRoomNode[]) => void;
  openTag: (node: DataRoomNode) => void;
  onTagSet: (node: DataRoomNode) => void;
  removeTagFromOldNode: (nodeId: string) => void;
};

export default createContext<DataRoomNodeActionsContextType>(null);
